import React, {
  memo,
  createElement,
  ElementType,
  ComponentPropsWithoutRef
} from 'react'

interface IHighlightedTextProps {
  text: string
  elementType: ElementType
  attributes?: ComponentPropsWithoutRef<ElementType>
}

const getHighlightedText = (
  startIndex: number,
  endIndex: number,
  text: string
): string => text.slice(startIndex, endIndex).replace(/[<>]/g, '')

const HighlightedText: React.FC<IHighlightedTextProps> = ({
  text,
  elementType,
  attributes = {}
}) => {
  const parts: (string | React.ReactNode)[] = []
  let lastIndex = 0
  let currentIndex = 0
  let partIndex = 0

  while (currentIndex < text.length) {
    const startIndex = text.indexOf('<', currentIndex)
    if (startIndex === -1) {
      parts.push(text.slice(lastIndex))
      break
    }

    const endIndex = text.indexOf('>', startIndex)
    if (endIndex === -1) {
      parts.push(text.slice(lastIndex))
      break
    }

    // Add text before highlight
    if (startIndex > lastIndex) {
      parts.push(text.slice(lastIndex, startIndex))
    }

    // Add highlighted text
    const highlightedText = getHighlightedText(startIndex, endIndex, text)
    parts.push(
      createElement(
        elementType,
        { ...attributes, key: `highlight-${partIndex}` },
        highlightedText
      )
    )

    lastIndex = endIndex + 1
    currentIndex = endIndex + 1
    partIndex++
  }

  return (
    <>
      {parts.map((part, index) => {
        if (typeof part === 'string') {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={`text-${lastIndex}-${index}`}>
              {part}
            </React.Fragment>
          )
        }
        return part
      })}
    </>
  )
}

export default memo(HighlightedText)
